import styled from 'styled-components';

export const OurSupportersMain = styled.section`
    margin-top: 0px;
    margin-bottom: 0px;
    background:#F1FEFF;
    padding-bottom:0px;
    .gray-back{
        background: #F5F5F5;
        box-shadow: 0px 20px 20px #0000001A;
        border-radius: 15px;
        padding: 20px 8px;
        row-gap: 20px;
        justify-content: space-between;
        @media screen and (max-width: 1199px){
              margin: 0;
        }
    }
`;
export const SupportersMainLogo = styled.div`
    position: relative;
    top: -125px;
    margin-bottom: -50px;
`;

export const OurSupportersBox = styled.div`
    display: flex;
    justify-content: center;

    &:nth-child(3n + 1) {
        justify-content: flex-start !important;
    }
    &:nth-child(3n) {
        justify-content: flex-end !important;
    }
`;
export const OurSupportBoxInner = styled.div`
    max-width: 358px;
    width: 100%;
    min-height: 112px;
    height: 100%;
    background: #FFFFFF;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 1200px){
        max-width: 100%;
    }
`;